import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Broker } from '../../models/broker';
import { UsersService } from '../../../services/users/users.service';
import { FTLCustomer } from 'src/app/models/ftl-customer';
import { MarginService } from 'src/services/margin/margins.service';

@Injectable()
export class CustomerResolver implements Resolve<FTLCustomer[]> {

  constructor(
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private marginService: MarginService
  ) {}
  
  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    return Promise.resolve(null);
  }
}
